// ABCDE FGHIJ KLMNO PQRST UVWXYZ
const dictionary = {
  ' ': ' ',
  '-': '-',
  '.': '.',

  A: 'А',
  B: 'Б',
  C: 'Ц',
  CH: 'Ч',
  D: 'Д',
  E: 'Е',

  F: 'Ф',
  G: 'Г',
  H: 'Х',
  IA: 'Я',
  IE: 'Ъ',
  IU: 'Ю',
  I: 'И',
  J: 'Й',

  KH: 'Х',
  K: 'К',
  L: 'Л',
  M: 'М',
  N: 'Н',
  O: 'О',

  P: 'П',
  Q: '',
  R: 'Р',
  SHCH: 'Щ',
  SH: 'Ш',
  S: 'С',
  TS: 'Ц',
  T: 'Т',

  U: 'У',
  V: 'В',
  W: 'В',
  Y: 'Ы',
  ZH: 'Ж',
  Z: 'З',
};

export default function transliterate(str) {
  if (!str) {
    return '';
  }

  const res = str
    .toUpperCase()
    .replace('SHCH', 'Щ')
    .replace('CH', 'Ч')
    .replace('YA', 'Я')
    .replace('IA', 'Я')
    .replace('IE', 'Ъ')
    .replace('IU', 'Ю')
    .replace('KH', 'Х')
    .replace('SH', 'Ш')
    .replace('TS', 'Ц')
    .replace('TC', 'Ц')
    .replace('ZH', 'Ж');

  return res
    .split('')
    .map((letter) => {
      if (dictionary[letter]) {
        return dictionary[letter];
      }
      if (letter >= 'А' && letter <= 'Я') {
        return letter;
      }

      return '';
    })
    .join('')
    .toUpperCase();
}
